const roleDictionary = (role: any) => {
  switch (role) {
    case "SUPER_AGENT":
      return "panel/superAgent";
    case "AGENT":
      return "agent";
    case "DRIVER":
      return "panel/driver";
    case "PASSENGER":
      return "panel/passenger";
    case "ADMIN":
      return "panel/admin";
    case "MUNICIPALITY":
      return "panel/municipality";
    default:
      return role;
  }
};
export default roleDictionary;
